import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { palette } from '@m12s/component-library';
import { ACTIVITY_MODES } from 'lib/constants';
import { getOpenActivityTypeRef } from 'lib/selectors/getOpenActivity';
import { getSwitchActivityTypesOptions } from 'lib/selectors/getSwitchActivityTypesOptions';
import WorkOrderOpCard from 'components/SelectActivity/WorkOrderOpCard';
import { ActivityTypeRow } from 'components/ActivityTypeRow/ActivityTypeRow';
import {
  SelectActivityTableContainer,
  SelectActivityItemsContainer,
  SelectActivityItem,
} from './styled';

const activityModes = {
  [ACTIVITY_MODES.SETUP]: {
    color: palette.Yellow500,
    name: 'Setup',
    order: 0,
  },
  [ACTIVITY_MODES.PRODUCTION]: {
    color: palette.Teal500,
    name: 'Production',
    order: 1,
  },
};

const Table = ({ onActivityTypeSelect = () => {}, workOrderOp }) => {
  const activityTypes = useSelector(getSwitchActivityTypesOptions);
  const openActivityTypeRef = useSelector(getOpenActivityTypeRef);

  const onActivityTypeSelectWrapper = useCallback(
    (at, disabled) => {
      return (e) => {
        e.preventDefault();
        if (!disabled) {
          onActivityTypeSelect(at.activityTypeRef, at.activityMode);
        }
        return null;
      };
    },
    [onActivityTypeSelect]
  );

  const filteredActivityTypes = useMemo(() => {
    return activityTypes.sort((a, b) => {
      return `${activityModes[a.activityMode].order}${a.name}` >
        `${activityModes[b.activityMode].order}${b.name}`
        ? 1
        : -1;
    });
  }, [activityTypes]);

  return (
    <SelectActivityTableContainer>
      <WorkOrderOpCard workOrderOp={workOrderOp} />

      <SelectActivityItemsContainer>
        {filteredActivityTypes.map((at) => {
          // if stopAndStartRun, we allow user to select any activity
          const disabled = at.activityTypeRef === openActivityTypeRef;

          return (
            <SelectActivityItem key={at.activityTypeRef} className="item">
              <ActivityTypeRow
                activityType={at}
                activityModes={activityModes}
                disabled={disabled}
                onClick={onActivityTypeSelectWrapper}
              />
            </SelectActivityItem>
          );
        })}
      </SelectActivityItemsContainer>
    </SelectActivityTableContainer>
  );
};

Table.propTypes = {
  workOrderOp: PropTypes.object,
  onActivityTypeSelect: PropTypes.func,
};

export { Table };
